import { licenseApi } from "../../../../api/apiClient";

function getLicenses(search = "") {
  return licenseApi.get(`/admin/licenses?q=${search}`);
}

function getBanks(search, countryId) {
  if (search)
    return licenseApi.get(`/shared/license/banks/${countryId}?q=${search}`);
  return licenseApi.get(`/shared/license/banks/${countryId}?q=`);
}

function getLicense(id) {
  return licenseApi.get(`/bank/license/${id}`);
}

function updateLicense(data) {
  return licenseApi.post(`/admin/license/update`, data);
}

function generateLicense(data) {
  return licenseApi.post(`/admin/license/generate`, data);
}

function getModules() {
  return licenseApi.get(`/shared/license/modules`);
}

function getCountries() {
  return licenseApi.get(`/shared/license/countries`);
}

export const licenseServices = {
  getLicense,
  updateLicense,
  generateLicense,
  getModules,
  getLicenses,
  getBanks,
  getCountries,
};
